<h1 i18n="@@AddProductFromCatalog">Добавить товар из каталога</h1>

<p i18n="@@AddProductDescription">Заполните карточку товара, если не нашли нужный в каталоге. Позже менеджер поможет найти его, обсудить поставку или подобрать аналог. </p>

<form aria-labelledby="title">
  <app-search-autocomplete [mode]="'specification'"/>
</form>
